/* ==========================================================================
   Accessibility behaviour
   --------------------------------------------------------------------------
   Loaded from layout/theme.liquid after the theme bundles.

   assets/layout.theme.js and assets/vendors@layout.theme.js are webpack build
   artefacts and are not edited. Behaviour that would otherwise belong in them
   lives here and is attached by delegation from document, so it survives
   sections being re-rendered by the theme editor.
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------------------
     S7  No live regions anywhere in the theme

     A grep for aria-live across sections, snippets, layout, templates and
     blocks returned nothing before this pass. Adding to cart, cart total
     changes, and variant price and availability changes were all silent to a
     screen reader: the only feedback for add to cart was a drawer sliding in.

     window.announce() writes into the shared polite region in
     layout/theme.liquid. The text is cleared first and set on a timeout, so
     announcing the same string twice in a row still registers as a change.
     ---------------------------------------------------------------------- */
  window.announce = function (message) {
    var region = document.getElementById('a11y-announcer');
    if (!region || !message) return;
    region.textContent = '';
    window.setTimeout(function () {
      region.textContent = message;
    }, 100);
  };

  // Add to cart. The handler that opens the drawer lives in
  // assets/layout.theme.js, which is a build artefact, so this listens
  // alongside it rather than editing it.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('#addCart, .quickAdd__variant') : null;
    if (!btn || btn.hasAttribute('disabled')) return;

    // Product page: the title is the h1 inside the product section. Quick add
    // buttons elsewhere have no reliable title nearby, so they fall back to
    // the generic message.
    var h1 = document.querySelector('.product h1');
    var name = h1 ? h1.textContent.replace(/\s+/g, ' ').trim() : '';
    window.announce(name ? name + ' added to your cart' : 'Added to your cart');
  });

  /* ------------------------------------------------------------------------
     S15  Header search and account panel toggles

     Both are now buttons carrying aria-expanded, but the panels themselves
     are opened by jQuery fadeToggle inside assets/layout.theme.js, which is a
     build artefact. Rather than reimplement the toggle, this reads the panel's
     actual visibility once the fade has finished and syncs the attribute to
     what really happened. jQuery's default fade is 400ms.

     The mobile menu and account modal triggers are not handled here. They go
     through Foundation, so the C9 block below keeps their aria-expanded in
     sync from Foundation's own open and close events.
     ---------------------------------------------------------------------- */
  function syncPanelState(toggleId, panelSelector) {
    var toggle = document.getElementById(toggleId);
    var panel = document.querySelector(panelSelector);
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function () {
      window.setTimeout(function () {
        var open = panel.offsetParent !== null;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }, 450);
    });
  }

  syncPanelState('search-icon', '.search-menu');
  syncPanelState('account-icon', '.account-menu');


  /* ------------------------------------------------------------------------
     2.2.2  Carousels rotate automatically with no way to stop them

     Both the announcement bar (autoplay, 4750ms) and the home page hero
     (autoplay, 2200ms) rotate indefinitely.

     An earlier version of this block stopped the announcement bar outright,
     and an earlier version than that added a visible pause button. Both were
     wrong for this site. The button read as stray punctuation. Stopping the
     bar meant two of its three announcements were only reachable by clicking
     an arrow, which trades a minor accessibility problem for a real content
     one, on a decision that belongs to whoever writes the announcements.

     What this does instead is honour prefers-reduced-motion. That OS level
     setting is how someone with a vestibular disorder, or anyone who finds
     moving content hard to read past, tells every site at once that they do
     not want animation. Respecting it stops the carousels for exactly the
     people the criterion exists to protect and changes nothing for everyone
     else. It is also live: toggling the OS setting stops or restarts rotation
     without a reload.

     Being straight about the limit: this does not fully satisfy 2.2.2, which
     asks for a mechanism available to all users, not only to those who have
     set a preference. The W3C's own carousel pattern includes a play and
     pause control. That control is not here by choice, and the residual gap
     is recorded rather than papered over.

     Worth recording what already mitigates it, verified in the bundled slick
     rather than assumed: pauseOnFocus and pauseOnHover both default to true
     and neither carousel overrides them, so rotation already stops while a
     keyboard user is tabbing through a carousel or a mouse user is reading
     one. The gap that remains is touch, where there is no hover and no focus.

     Separately, and not an accessibility point: the hero's 2200ms is too fast
     to read a heading and click its button. Raising it in the theme editor
     would be a usability win on its own terms.
     ---------------------------------------------------------------------- */
  (function respectReducedMotion() {
    // The page carries two jQuery objects and slick is registered on only one
    // of them. window.jQuery.fn.slick is undefined here while window.$.fn.slick
    // is a function, so calling through the wrong one throws
    // "slick is not a function" and, inside a try/catch, fails silently. Pick
    // the instance that actually has the plugin.
    var jq = (window.$ && window.$.fn && window.$.fn.slick) ? window.$ : window.jQuery;
    if (!jq || !jq.fn || !jq.fn.slick) return;
    if (!window.matchMedia) return;

    var query = window.matchMedia('(prefers-reduced-motion: reduce)');

    function apply() {
      jq('.slick-initialized').each(function () {
        try {
          jq(this).slick(query.matches ? 'slickPause' : 'slickPlay');
        } catch (e) { /* carousel torn down between selection and call */ }
      });
    }

    // Carousels initialise at different times, so poll briefly rather than
    // racing a single ready handler.
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (jq('.slick-initialized').length) {
        apply();
        window.clearInterval(timer);
      } else if (tries > 40) {
        window.clearInterval(timer);
      }
    }, 150);

    // React to the preference changing mid-session.
    if (query.addEventListener) query.addEventListener('change', apply);
    else if (query.addListener) query.addListener(apply);

    // Slick rebuilds on responsive breakpoints, which restarts autoplay.
    jq(document).on('init.slick setPosition.slick', function () {
      if (query.matches) apply();
    });
  })();


  /* ------------------------------------------------------------------------
     4.1.2  Slick puts focusable content inside an aria-hidden slide

     During every transition slick sets the incoming slide's tabindex to 0
     while its aria-hidden is still "true", and leaves the links inside it
     tabbable throughout. For the ~400ms of the animation the slide is hidden
     from assistive technology but still reachable by Tab, which is exactly
     what axe's aria-hidden-focus rule prohibits.

     On the home page hero this recurs every 2.2 seconds, so a keyboard user
     can land on a button that a screen reader will not announce. Sampling the
     DOM ten times a second caught slick-slide02, 03 and 04 in that state.

     A MutationObserver is used rather than slick's own beforeChange and
     afterChange events because the bad state exists *between* those events.
     Watching the attribute itself means the correction lands in the same
     microtask that slick's write does, rather than one animation later.

     Original tabindex values are recorded so restoring cannot invent a tab
     stop that the markup never had.
     ---------------------------------------------------------------------- */
  (function syncSlickSlideFocusability() {
    if (!window.MutationObserver) return;

    var FOCUSABLE = 'a[href], button, input, select, textarea, iframe, [tabindex]';
    var SAVED = 'data-a11y-tabindex';

    function setTab(node, value) {
      // Guarded: setAttribute fires a mutation even when the value is
      // unchanged, which would make this observer retrigger itself forever.
      if (node.getAttribute('tabindex') !== value) node.setAttribute('tabindex', value);
    }

    function sync(slide) {
      var hidden = slide.getAttribute('aria-hidden') === 'true';

      // slick marks the slide itself focusable before clearing aria-hidden.
      if (hidden) setTab(slide, '-1');

      var nodes = slide.querySelectorAll(FOCUSABLE);
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (hidden) {
          if (!n.hasAttribute(SAVED)) {
            var current = n.getAttribute('tabindex');
            n.setAttribute(SAVED, current === null ? '' : current);
          }
          setTab(n, '-1');
        } else if (n.hasAttribute(SAVED)) {
          var prev = n.getAttribute(SAVED);
          n.removeAttribute(SAVED);
          if (prev === '') n.removeAttribute('tabindex');
          else setTab(n, prev);
        }
      }
    }

    function syncAll(root) {
      var slides = root.querySelectorAll('.slick-slide');
      for (var i = 0; i < slides.length; i++) sync(slides[i]);
    }

    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var rec = records[i];
        var t = rec.target;

        if (rec.type === 'attributes') {
          if (t.classList && t.classList.contains('slick-slide')) sync(t);
          continue;
        }

        // childList. Only slides being added counts: slick clones slides when
        // it initialises and again on responsive rebuilds. Klaviyo, the cart
        // drawer and every other script on the page also mutate the DOM, and
        // resyncing every carousel for each of those would be pure waste.
        for (var j = 0; j < rec.addedNodes.length; j++) {
          var n = rec.addedNodes[j];
          if (n.nodeType !== 1) continue;
          if (n.classList.contains('slick-slide')) sync(n);
          else if (n.querySelector && n.querySelector('.slick-slide')) syncAll(n);
        }
      }
    });

    function start() {
      syncAll(document);
      observer.observe(document.body, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['aria-hidden', 'tabindex'],
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();


  /* ------------------------------------------------------------------------
     C1  Desktop mega menu opened by hover only

     .navigation__container .navigation__megamenu > li.mega-drop-down:hover
     .mega-menu was the only thing that opened the panel. There was no
     :focus-within rule, no aria-expanded and no JS, so every link inside
     every mega menu was unreachable without a mouse. The closed state is
     visibility:hidden, so those links were absent from the tab order and from
     the accessibility tree entirely.

     Each panel now has a sibling toggle button. Opening adds .is-open to the
     li, which a11y.css keys off with the same specificity as the hover rule.
     Hover still works and is untouched.
     ---------------------------------------------------------------------- */
  var OPEN = 'is-open';

  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  function closeMenu(item) {
    if (!item || !item.classList.contains(OPEN)) return;
    item.classList.remove(OPEN);
    var toggle = item.querySelector('.mega-menu-toggle');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function closeAllMenus(except) {
    var open = document.querySelectorAll('.mega-drop-down.' + OPEN);
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== except) closeMenu(open[i]);
    }
  }

  document.addEventListener('click', function (e) {
    var toggle = closest(e.target, '.mega-menu-toggle');

    if (!toggle) {
      // A click anywhere else closes any open panel, matching the way the
      // hover version disappears when the pointer leaves.
      if (!closest(e.target, '.mega-drop-down.' + OPEN)) closeAllMenus(null);
      return;
    }

    e.preventDefault();

    var item = closest(toggle, '.mega-drop-down');
    if (!item) return;

    var willOpen = !item.classList.contains(OPEN);
    closeAllMenus(item);

    if (willOpen) {
      item.classList.add(OPEN);
      toggle.setAttribute('aria-expanded', 'true');
    } else {
      closeMenu(item);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;

    var item = closest(e.target, '.mega-drop-down.' + OPEN);
    if (!item) return;

    var toggle = item.querySelector('.mega-menu-toggle');
    closeMenu(item);
    if (toggle) toggle.focus();
  });

  // Tabbing out of a panel closes it. Deferred so document.activeElement has
  // settled on the element that is receiving focus.
  document.addEventListener('focusout', function (e) {
    var item = closest(e.target, '.mega-drop-down.' + OPEN);
    if (!item) return;

    window.setTimeout(function () {
      if (!item.contains(document.activeElement)) closeMenu(item);
    }, 0);
  });


  /* ------------------------------------------------------------------------
     C9  Focus is never returned to the trigger when an overlay closes

     Containment itself is handled in markup: data-trap-focus="true" on
     #offCanvas and #offCanvasCart. Verified against the bundled Foundation in
     assets/vendors@layout.theme.js, where the OffCanvas defaults are
     { ... autoFocus:!0, revealClass:"reveal-for-", trapFocus:!1 } and open()
     runs !0===this.options.trapFocus && H.trapFocus(this.$element). The option
     is real and was simply never switched on.

     Reveal is different. Its defaults object contains no trapFocus key at all,
     and open() calls H.trapFocus(this.$element) unconditionally, so
     #accountModal already contains focus and needs no attribute. The audit's
     C9 table was wrong to list it as untrapped; adding data-trap-focus there
     would have been a no-op on an unrecognised option.

     What neither plugin does is put focus back where it came from. Closing an
     overlay drops focus to <body>, so the next Tab restarts from the skip
     link at the top of the page. That is what this block fixes.
     ---------------------------------------------------------------------- */
  var lastTrigger = null;

  // Capture phase, so the opener is recorded even if a handler further down
  // stops propagation.
  document.addEventListener('click', function (e) {
    var t = closest(e.target, '[data-toggle], [data-open]');
    if (t) lastTrigger = t;
  }, true);

  if (window.jQuery) {
    jQuery(document).on('opened.zf.offCanvas opened.zf.reveal', function () {
      if (lastTrigger && lastTrigger.hasAttribute('aria-expanded')) {
        lastTrigger.setAttribute('aria-expanded', 'true');
      }
    });

    jQuery(document).on('closed.zf.offCanvas closed.zf.reveal', function () {
      var t = lastTrigger;
      lastTrigger = null;
      if (!t || !document.contains(t)) return;
      if (t.hasAttribute('aria-expanded')) t.setAttribute('aria-expanded', 'false');
      t.focus();
    });
  }

  /* ------------------------------------------------------------------------
     2.4.4 and 1.1.1  Article images that link to their full-size file

     Older articles were imported with images wrapped in a link to the image
     file and no alt text, so the link has no name at all and a screen reader
     announces only the file URL. The content lives in the article body, not
     the theme, so it cannot be corrected in a template.

     This names the link by what it does. It is a fallback: it does not
     describe the picture, and an image given real alt text in the article
     editor is left untouched.
     ---------------------------------------------------------------------- */
  (function nameArticleImageLinks() {
    var heading = document.querySelector('article h1');
    var title = heading ? heading.textContent.replace(/\s+/g, ' ').trim() : document.title;
    var links = document.querySelectorAll('article .rte a');
    var n = 0;

    Array.prototype.forEach.call(links, function (link) {
      var img = link.querySelector('img');
      if (!img) return;
      if (link.textContent.trim() || link.getAttribute('aria-label')) return;
      if ((img.getAttribute('alt') || '').trim()) return;

      n += 1;
      img.setAttribute('alt', '');
      link.setAttribute('aria-label', 'View full-size image ' + n + ' from ' + title);
    });
  })();
})();
